import useSWR, { SWRConfiguration } from 'swr'
import axios from 'axios'

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_GATEWAY_URL
})

export function useFetch<Data = any, Error = any>(
  url: string,
  options?: SWRConfiguration<Data, Error>
) {
  //eslint-disable-line
  const { data, error, mutate } = useSWR<Data, Error>(
    url,
    async key => {
      const response = await api.get(key)

      return response.data
    },
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
      ...options
    }
  )

  return { data, error, mutate }
}

class Sdk {
  async getCompanies(): Promise<Company[]> {
    const { data } = await api.get('/companies')
    return data
  }

  async getPaymentTypes(): Promise<PaymentType[]> {
    const { data } = await api.get('/payment_types')
    return data
  }

  async getWriteOffTypes(): Promise<WriteOffType[]> {
    const { data } = await api.get('/write_off_types')
    return data
  }
}

export const sdk = new Sdk()
